<template>
  <div class="page-content">
    <md-whiteframe md-tag="md-toolbar" md-elevation="1" class="main-header">
      <md-button class="md-icon-button nav-trigger" @click="toggleSidenav">
        <md-icon>menu</md-icon>
      </md-button>

      <div class="md-title">{{ pageTitle }}</div> 

      <md-button rel="noopener" class="md-icon-button" v-on:click="signout()">
        <md-icon>exit_to_app</md-icon>
      </md-button>
    </md-whiteframe>
    <slot></slot>

      <md-bottom-bar md-shift v-if="auth.isAdministrative">
        <md-bottom-bar-item @click.native="redirect('masters:color','blue')" md-icon="airport_shuttle"> Entry </md-bottom-bar-item>
        <md-bottom-bar-item @click.native="redirect('masters:flow','teal')" md-icon="notifications"> Request </md-bottom-bar-item>
        <md-bottom-bar-item @click.native="redirect('masters:color','brown')" md-icon="local_car_wash" > Status </md-bottom-bar-item>
        <md-bottom-bar-item @click.native="redirect('masters:color','indigo')" md-icon="history"> Histories </md-bottom-bar-item>
        <md-bottom-bar-item @click.native="redirect('maps','blue-grey')" md-icon="place" md-active> Maps </md-bottom-bar-item>
      </md-bottom-bar> 
  </div>
</template>

<style lang="scss" scoped>
  .page-content {
    min-height: 100%;
    max-height: 100%;
    flex: 1;
    display: flex;
    flex-flow: column
  }

  .main-header {
    z-index: 2;
    color: #fff !important;
  }

  .nav-trigger {
    @media (min-width: 1281px) {
      display: none;
    }
  }

  .md-title {
    flex: 1;

    @media (min-width: 1281px) {
      margin-left: 8px;
    }
  }

  .github {
    @media (max-width: 480px) {
      display: none;
    }
  }
</style>

<script>
  import Vue from 'vue';
  import auth from './../scripts/modules/auth.js';
  import {router} from './../main.js';
  export default {
    data() {
      return {
        auth: {
          isAdministrative: false
        }
      };
    },
    props: {
      pageTitle: String
    },
    methods: {
      redirect(url, theme) {
        Vue.material.setCurrentTheme(theme);
        router.push({
          name: url
        });
      },
      toggleSidenav() {
        this.$root.toggleSidenav();
      },
      signout() {
        auth.signout();
      }
    },
    mounted() {
      document.title = this.pageTitle + ' - Valet Parking';
      if (auth.user.profile === null ) {
        router.push({
          name: 'signin'
        });
      } else if (auth.user.profile.role.rlms_id === 20) {
        this.auth.isAdministrative = true;
      }
    }
  };
</script>



// WEBPACK FOOTER //
// PageContent.vue?5a013890